/**
 * A group's pager: where the reader is in a long list ("21–40 of 154") and the
 * two arrows that move a page. Prints nothing when the list fits on one page.
 */
import { Btn } from "./primitives.js";

export interface PagerProps {
  page: number;
  pageSize: number;
  total: number;
  onPage: (page: number) => void;
  /** What the arrows move, for a screen reader ("held reviews"). */
  label: string;
}

export function Pager({ page, pageSize, total, onPage, label }: PagerProps) {
  if (total <= pageSize) return null;
  const last = Math.ceil(total / pageSize);
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);
  const n = (value: number) => value.toLocaleString("en-US");
  return (
    <span className="pager" role="group" aria-label={`Pages of ${label}`}>
      <span className="fact">
        {n(from)}–{n(to)} of {n(total)}
      </span>
      <Btn icon aria-label="Previous page" disabled={page <= 1} onClick={() => onPage(page - 1)}>
        ‹
      </Btn>
      <Btn icon aria-label="Next page" disabled={page >= last} onClick={() => onPage(page + 1)}>
        ›
      </Btn>
    </span>
  );
}
